import {
    I18NData,
    I18NPayload,
    I18N_LANGUAGE
} from "./types";

const initialState: I18NData = {
    language: "ENG"
};

export function I18N(
    state = initialState,
    action: I18NPayload
): I18NData {
    switch (action.type) {
        case I18N_LANGUAGE:
            return action.data;
        default:
            return state;
    }
}
